// Zenuva Goda-style page — shared behavior. Include once via theme.liquid, not per-section.
document.addEventListener('DOMContentLoaded', function () {

  // Gallery: thumbnail rail updates its own main image (data-main-target holds the main <img> id)
  document.querySelectorAll('.zg-gal-thumbs').forEach(function (rail) {
    rail.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      var main = document.getElementById(rail.dataset.mainTarget);
      if (main) main.src = b.dataset.src;
      rail.querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      b.setAttribute('aria-current', 'true');
    });
  });

  // Real discount codes for the one-time bundle tiers (2 bottles / 3 bottles).
  // These are live Shopify discounts (ZENUVA-DUO15, ZENUVA-TRIO30) — auto-applied
  // via Shopify's /discount/{code} URL so customers never have to type a code.
  var ZG_BUNDLE_CODES = { '2': 'ZENUVA-DUO15', '3': 'ZENUVA-TRIO30' };

  document.querySelectorAll('.zg-selector-card').forEach(function (card) {
    var qtyInput = card.querySelector('[data-zg="qty-input"]');
    var planSelect = card.querySelector('[data-zg="selling-plan-select"]');
    var form = card.closest('form');

    card.querySelectorAll('.zg-sel-tile').forEach(function (tile) {
      tile.addEventListener('click', function () {
        card.querySelectorAll('.zg-sel-tile').forEach(function (t) { t.setAttribute('aria-checked', 'false'); });
        tile.setAttribute('aria-checked', 'true');
        if (qtyInput) qtyInput.value = tile.dataset.qty || '1';
        if (planSelect && tile.dataset.mode === 'subscribe') {
          var activePlanBtn = card.querySelector('.zg-freq-btn[aria-checked="true"][data-plan-id]');
          if (activePlanBtn) planSelect.value = activePlanBtn.dataset.planId;
        } else if (planSelect) {
          planSelect.value = '';
        }
      });
    });

    card.querySelectorAll('.zg-freq-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('.zg-freq-row');
        row.querySelectorAll('.zg-freq-btn').forEach(function (x) { x.setAttribute('aria-checked', 'false'); });
        btn.setAttribute('aria-checked', 'true');
        if (planSelect && btn.dataset.planId) {
          planSelect.value = btn.dataset.planId;
          var subscribeTile = card.querySelector('.zg-sel-tile[data-mode="subscribe"]');
          if (subscribeTile) subscribeTile.click();
        }
      });
    });

    // On submit: if a 2x/3x one-time tile is selected, add to cart first, then
    // route through Shopify's discount auto-apply URL so the price is correct
    // on the cart page without the customer typing anything.
    if (form) {
      form.addEventListener('submit', function (e) {
        var activeTile = card.querySelector('.zg-sel-tile[aria-checked="true"]');
        if (!activeTile) return;
        var qty = activeTile.dataset.qty;
        var mode = activeTile.dataset.mode;
        var code = mode === 'onetime' ? ZG_BUNDLE_CODES[qty] : null;
        if (!code) return;
        e.preventDefault();
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then(function () {
            window.location.href = '/discount/' + code + '?redirect=/cart';
          })
          .catch(function () {
            form.submit();
          });
      });
    }
  });
});
